module.exports = __webpack_public_path__ + "media/fonts/aileron-light-webfont-ba87c6d9.woff";